/* eslint-disable linebreak-style */
import React from 'react';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';
import useDeviceScreen from 'root/hooks/useDeviceScreen';
import { useAmp } from 'next/amp';

const Loading = ({ mobile, desktop }) => {
  const { isMobile } = useDeviceScreen();
  const isAmp = useAmp();
  const width = (isAmp || isMobile) ? mobile.width : desktop.width;
  const height = (isAmp || isMobile) ? mobile.height : desktop.height;

  return !isMobile ? (
    <ContentLoader
      speed={9}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="3" y="1" rx="0" ry="0" width="644" height="3" />
      <rect x="3" y="16" rx="0" ry="0" width="430" height="20" />
      <rect x="3" y="65" rx="0" ry="0" width="310" height="180" />
      <rect x="3" y="260" rx="0" ry="0" width="160" height="13" />
      <rect x="3" y="284" rx="0" ry="0" width="300" height="16" />
      <rect x="337" y="65" rx="0" ry="0" width="310" height="180" />
      <rect x="337" y="260" rx="0" ry="0" width="160" height="13" />
      <rect x="337" y="284" rx="0" ry="0" width="300" height="16" />
    </ContentLoader>
  ) : (
    <ContentLoader
      speed={9}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="3" y="1" rx="0" ry="0" width="480" height="3" />
      <rect x="3" y="16" rx="0" ry="0" width="400" height="20" />
      <rect x="3" y="65" rx="0" ry="0" width="480" height="180" />
      <rect x="3" y="260" rx="0" ry="0" width="160" height="13" />
      <rect x="3" y="284" rx="0" ry="0" width="300" height="16" />
    </ContentLoader>
  );
};

Loading.propTypes = {
  mobile: PropTypes.object,
  desktop: PropTypes.object,
};

export default Loading;
